import { Component, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';
import { ToolService, ToolNumberService, ToolTypeService, ToolDescriptionByTypeService } from '../../../camtl.service';

import { Tool } from '../../../../../shared/model';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolHandednessService } from '../../../../mesc/mesc.service';
import { MasterToolListBase } from '../../master-tool-list-base.component';
import { Subscription } from 'rxjs/Subscription';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../../../auth.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-legacy-tools',
  templateUrl: './legacy-tools.component.html',
  // styleUrls: ['./legacy-tools.component.scss']
})
export class LegacyToolsComponent extends MasterToolListBase implements OnInit, OnDestroy {

  constructor(
    public toolTypeService: ToolTypeService,
    public service: ToolService,
    private systemSelectService: SystemSelectService,
    private toolNumberService: ToolNumberService,
    private formBuilder: FormBuilder,
    private toolHandednessService: ToolHandednessService,
    public toolDescriptionService: ToolDescriptionByTypeService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private authService: AuthenticationService,
    public routeValidationService: RouteValidationService) {
    super(toolTypeService, "Legacy Tool", toolDescriptionService);
    this.isAdmin = authService.isClaimValid("/MESC/CAMTL/Administration")
  }
  isAdmin: boolean = false;

  editForm: FormGroup;
  isNew: boolean = false;
  editDataItem: Tool;
  excludeHandedness: boolean = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  columns: any[] = [{
    field: 'ToolDetail.ToolNumber',
    title: 'Tool Number',
    width: 175
  },
  {
    field: 'LegacyToolDescription',
    title: 'Description'
  },
  {
    field: 'AdditionalInfo',
    title: 'Additional Info'
  },
  {
    field: 'ToolHandedness',
    title: 'Design Handedness'
  },
  {
    field: 'LeftCount',
    title: 'LH',
    width: 70
  },
  {
    field: 'RightCount',
    title: 'RH',
    width: 70
  },
  {
    field: 'SingleCount',
    title: 'S',
    width: 70
  },
  {
    field: "MakeFurnish",
    title: "M/F",
    width: 70
  }];

  onRead = (): Promise<any> => {
    var self = this;
    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/LegacyTools')) {
      this.toolHandednessService.query();
      return this.toolTypeService.read()
        .then(function (response: any) {
          self.legacyToolId = response.filter(function (item) {
            return item.Description.toUpperCase() === "LEGACY TOOL";
          })[0].Id;

          return self.service.read('/' + self.system.Id + "/toolType/" + self.legacyToolId, true).then(function (response) {
            for (var i = 0; i < response.length; i++) {
              response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
            }
            return response;
          });
        })

    }
  }

  disableToolbar = (controlName: string) => {
    let isDisabled: boolean = false;
    if (!this.legacyToolId && controlName === "add") {
      isDisabled = true;
    }
    return isDisabled;
  }

  onToolSave = (dataItem, isNew) => {
    if (dataItem.EditToolNumber) {
      dataItem.ToolDetail.ToolNumber = dataItem.EditToolNumber;
      dataItem.ToolNumber = dataItem.EditToolNumber;
    } else if (!isNew) {
      dataItem.ToolNumber = dataItem.ToolDetail.ToolNumber;
    }

    if (isNew) {
      this.excludeHandedness = !this.toolNumberService.data.some(x => {
        let match = (x === dataItem.ToolNumber.toUpperCase());
        return match;
      });
    }
    dataItem.ExcludeHandedness = this.excludeHandedness;

    if (this.excludeHandedness) {
      var toolNumberObj = {
        value: dataItem.ToolNumber
      };
      var index = this.toolNumberService.data.indexOf(toolNumberObj);
    }
    this.service.save(dataItem, isNew, "", true, false)
      .then(() => {
        this.grid.refresh(true);
        this.excludeHandedness = false;
        this.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });

        this.toolNumberService.getBlockedToolNumbersForSystem(this.system.Id)
          .then(data => {
            data = data.sort((a, b) => {
              let check1: string = a.toUpperCase();
              let check2: string = b.toUpperCase();
              if (check1 < check2) return 1;
              if (check1 > check2) return -1;
              return 0;
            });

            if (data && data[0] && typeof data[0] === 'string')
              this.toolNumberService.next(data.map(x => <any>{ value: x }))
          });
      })
      .catch((response) => {
        this.service.loading.next(false);
        this.excludeHandedness = false;
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, '').replace(/Value cannot be null\.\\r\\nParameter name: /g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }


  handleDelete = (dataItem): Promise<any> => {
    return this.service.remove('/' + dataItem.Id);
  }

  handleHandednessChange = (toolHandednessId: string = "") => {
    var handednessName = "";

    let handedness = this.toolHandednessService.data.find(
      handedness => toolHandednessId === handedness.Id
    )

    if (handedness) {
      handednessName = handedness.Name
    }
    this.editForm.removeControl("LeftCount");
    this.editForm.removeControl("RightCount");
    this.editForm.removeControl("SingleCount");

    if (handednessName === "S") {
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }
    else if (handednessName === "L" || handednessName === "R") {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    } else {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }

  }

  handleToolNumberSelection = (e) => {
    if (!e) {
      this.excludeHandedness = true;
    }
    else {
      this.excludeHandedness = false;
    }
  }

  onEdit = (dataItem) => {
    this.handleHandednessChange(dataItem.ToolHandednessId);
    this.editForm.addControl('EditToolNumber', new FormControl({ value: '', disabled: !this.isAdmin }, Validators.required));
    this.editForm.removeControl('ToolNumber');

    dataItem.EditToolNumber = dataItem.ToolDetail.ToolNumber;
    this.editDataItem = dataItem;
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
      isDisabled: this.disableToolbar
    },
    read: this.onRead,
    save: this.onToolSave,
    delete: this.handleDelete,
    columns: this.columns,
    service: this.service,
    edit: this.onEdit,
    fileName: 'legacy_tools.xlsx',
    displayField: "DisplayNumber"
  };

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      Id: [],
      ToolDetail: [{ value: { ToolNumber: "" } }],
      ToolNumber: [],
      LegacyToolDescription: ["", Validators.required],
      AdditionalInfo: [""],
      ToolHandednessId: ["", Validators.required],
      DesignHandedness: [{ value: [] }],
      LeftCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      RightCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      SingleCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      CreatedDate: [],
      SystemId: [""],
      MakeFurnish: [""],
      JobNumber: [],
      ToolTypeId: []
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        this.editDataItem = undefined;
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/LegacyTools')) {
          this.toolNumberService.getBlockedToolNumbersForSystem(this.system.Id)
            .then(data => {
              data = data.sort((a, b) => {
                let check1: string = a.toUpperCase();
                let check2: string = b.toUpperCase();
                if (check1 < check2) return 1;
                if (check1 > check2) return -1;
                return 0;
              });

              if (data && data[0] && typeof data[0] === 'string')
                this.toolNumberService.next(data.map(x => <any>{ value: x }))
            });

          if (this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.template.controls.add = false;
            this.template.controls.edit = false;
            this.template.controls.delete = false;
          }
          else {
            this.template.controls.add = true;
            this.template.controls.edit = true;
            this.template.controls.delete = true;
          }
        }
      });

    this.systemSelectService.get();
  }


  // stringToObjectArray(array) {
  //   var objectArray = [];
  //   for (var i = 0; i < array.length; i++) {
  //     var object = {
  //       value: array[i]
  //     };

  //     objectArray.push(object);
  //   }
  //   return objectArray;
  // }


  formDialog = {
    title: "Legacy Tool",
    formControls: [
      {
        type: 'combobox',
        name: 'ToolNumber',
        title: 'Tool Number',
        placeholder: 'Select Tool Number',
        service: this.toolNumberService,
        textField: "value",
        valueField: "value",
        allowCustom: true,
        sync: true
      },
      {
        type: 'text',
        name: "EditToolNumber",
        title: "Tool Number",
      },
      {
        type: 'text',
        name: "LegacyToolDescription",
        title: "Tool Description",
      },
      {
        type: 'text',
        name: 'AdditionalInfo',
        title: 'Additional Info'
      },
      {
        type: 'combobox',
        name: 'ToolHandednessId',
        title: 'Design Handedness',
        textField: 'Name',
        valueField: 'Id',
        onChange: this.handleHandednessChange,
        placeholder: 'Select Design Handedness...',
        service: this.toolHandednessService
      },
      {
        type: 'number',
        name: 'LeftCount',
        title: 'LH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'RightCount',
        title: 'RH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'SingleCount',
        title: 'S',
        minimum: 0,
        step: 1
      },
      {
        type: 'presetCombobox',
        name: 'MakeFurnish',
        title: 'M/F',
        placeholder: 'M/F',
        textField: 'value',
        valueField: 'value',
        data: [
          { "value": "M" },
          { "value": "F" }
        ]
      }
    ]
  }

  setModelHandler() {
    this.toolNumberService;
    this.editDataItem = new Tool();
    this.editForm.removeControl('EditToolNumber');
    this.editForm.addControl('ToolNumber', new FormControl('', Validators.required));

    this.editDataItem.ToolTypeId = this.legacyToolId;
    this.editDataItem.MakeFurnish = "M";
    this.editDataItem.LeftCount = 0;
    this.editDataItem.RightCount = 0;
    this.editDataItem.SingleCount = 0;
    this.editForm.addControl("LeftCount", new FormControl(0, Validators.required));
    this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    this.editDataItem.JobNumber = 0;

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }


}
